import ApplicationController from './application_controller'
import consumer from '../channels/consumer'
import CableReady from 'cable_ready'

/* Givsum 3.0 vanilla-JS counterpart to auction_item_controller.js (which stays
 * jQuery-based and untouched, in case the legacy item page is ever reused).
 *
 * Nothing on show_v3 previously subscribed to the per-item AuctionItemChannel,
 * so BidReflex/CancelBidReflex's live swaps of the bid history table
 * (#bids_history_...), the price/bid-count header (#header_...), and the bid
 * form (#bid_form_...) were broadcast but never received — the page only
 * reflected a bid/cancel after a manual reload. This wires that channel up.
 */
export default class extends ApplicationController {
  connect() {
    super.connect()

    const auctionItemId = this.element.dataset.auctionItemId
    if (!auctionItemId) return

    consumer.subscriptions.create({ channel: 'AuctionItemChannel', auction_item_id: auctionItemId }, {
      received: (data) => {
        if (!data.cableReady) return
        CableReady.perform(data.operations)
        fixBidderIdFields()
        refreshOutbidIndicator()
      },
    })
  }
}

function fixBidderIdFields() {
  if (!window.givsum_user_id) return
  document.querySelectorAll('input[name="bidder_id"]').forEach((field) => {
    if (!field.value || String(field.value) !== String(window.givsum_user_id)) {
      field.value = window.givsum_user_id
    }
  })
}

function refreshOutbidIndicator() {
  const indicator = document.getElementById('outbid_indicator')
  if (!indicator) return
  try {
    const myBids = JSON.parse(localStorage.getItem('userBids') || '[]')
    const hasOutbids = myBids.some((bid) => bid.winning_bid === false)
    indicator.classList.toggle('d-none', !hasOutbids)
  } catch (e) {
    // malformed localStorage, ignore
  }
}
